/* eslint-disable @typescript-eslint/no-unused-expressions */
import { BatchPlus } from '@components/Sales/batch.type'
import BatchPlusComparisonModal from '@components/Sales/BatchPlusComparisonModal'
import BatchUserModal from '@components/Sales/BatchUserModal/BatchUserModal'
import UserRegistrationModal from '@components/Sales/UserRegistrationModal/UserRegistrationModal'
import { Base64 } from '@utils/encode-utilities'
import React, { createContext, useContext, useState } from 'react'

interface modalProps {
  plansData?: BatchPlus
}

interface eventProps {
  popupCtaName: string
  pageName: string
  batchName: string
  batchId: string
  selectedPlanId?: string
  selectHighestPlan?: boolean
}

interface BatchPlusModalContextType {
  openComparisonTable: (props: modalProps & eventProps) => void
  closeComparisonTable: () => void
}

const BatchPlusModalContext = createContext<
  BatchPlusModalContextType | undefined
>(undefined)

export const BatchPlusModalProvider: React.FC<{
  children: React.ReactNode
}> = ({ children }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [config, setConfig] = useState<BatchPlus | null>(null)
  const [eventDetails, setEventDetails] = useState<eventProps | null>(null)
  const [isUserModalOpen, setIsUserModalOpen] = useState<boolean>(false)
  const [selectedPlan, setSelectedPlan] = useState({})
  const [isUserRegisterModalOpen, setIsUserRegisterModalOpen] = useState(false)
  const [enteredUserData, setEnteredData] = useState()
  const openComparisonTable = (props: modalProps & eventProps) => {
    if (props?.plansData) {
      setConfig(props?.plansData)
    }
    setEventDetails({
      pageName: props?.pageName,
      popupCtaName: props?.popupCtaName,
      batchName: props?.batchName,
      batchId: props?.batchId,
      selectedPlanId: props?.selectedPlanId,
      selectHighestPlan: props?.selectHighestPlan,
    })
    setIsOpen(true)
  }

  const closeComparisonTable = (clickedFrom?: any, plan?: any) => {
    console.log('hello', plan)
    if (eventDetails?.pageName === 'order_summary') {
      setConfig(null)
      setIsOpen(false)
      const params = new URLSearchParams(window.location.search)
      const info = params.get('info') || ''
      const infoObject = JSON.parse(Base64.decode(info) || '{}')
      const updatedInfoObject: any = {
        ...infoObject,
        cameFrom: 'batch-details',
      }
      if (plan?.batchId) {
        updatedInfoObject.batchSlug = plan?.batchId
      }
      if (plan?._id) {
        updatedInfoObject.planId = plan?._id
      }
      let base64Info = btoa(JSON.stringify(updatedInfoObject))
      window.location.href = `/sales/order-summary?info=${base64Info}&planId=${plan?._id}`
    } else {
      setConfig(null)
      setIsOpen(false)
      if (clickedFrom !== 'close_icon') {
        setSelectedPlan(plan)
        setIsUserModalOpen(true)
      }
    }
  }
  const handleBatchUserModal = (registerUserData: any) => {
    setIsUserModalOpen(false)
    setEnteredData(registerUserData)
    setIsUserRegisterModalOpen(true)
  }

  console.log('context', selectedPlan)
  return (
    <>
      <BatchPlusModalContext.Provider
        value={{ openComparisonTable, closeComparisonTable }}
      >
        {children}
        {isOpen && (
          <BatchPlusComparisonModal
            config={config || undefined}
            open={isOpen}
            eventDetails={eventDetails!}
            onClose={closeComparisonTable}
          />
        )}
      </BatchPlusModalContext.Provider>
      {isUserModalOpen && (
        <BatchUserModal
          isOpen={isUserModalOpen}
          onClose={() => {
            setIsUserModalOpen(false)
            setIsOpen(true)
          }}
          selectedPlan={selectedPlan}
          partPayment={false}
          handleBatchUserModal={handleBatchUserModal}
        />
      )}
      {isUserRegisterModalOpen && (
        <UserRegistrationModal
          isOpen={isUserRegisterModalOpen}
          onClose={() => setIsUserRegisterModalOpen(false)}
          enteredUserData={enteredUserData}
          selectedPlan={selectedPlan}
        />
      )}
    </>
  )
}

export const useOpenComparisonModal = (): BatchPlusModalContextType => {
  const context = useContext(BatchPlusModalContext)
  if (!context) {
    throw new Error(
      'useOpenComparisonModal must be used within a ModalProvider'
    )
  }
  return context
}
